// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAction } from 'typesafe-actions';
import { RunningLab } from '../../types/Model';

type UpdateRunningChallengeActionPayload = Partial<RunningLab>

export const updateRunningChallengeAction = createAction(
  'elearning/UPDATE_RUNNING_CHALLENGE',
  (runningChallenge: UpdateRunningChallengeActionPayload) => (runningChallenge),
)<UpdateRunningChallengeActionPayload>();

export const clearRunningChallengeAction = createAction('elearning/CLEAR_RUNNING_CHALLENGE')();
